import { createContext, useContext } from "react";
import { ApplicationEditorController } from "./applicationEditorController";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ApplicationEditorControllerContext = createContext<ApplicationEditorController>(null as any);
export const useApplicationEditorController = (): ApplicationEditorController =>
	useContext(ApplicationEditorControllerContext);
